import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button, Card, Text } from "@andrum/ui";
import {
  fetchHomework,
  type HomeworkPayload,
} from "@/features/practice/api/practice-api";
import { useAuthStore } from "@/stores/auth-store";

export function ClinicianHomeworkCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const status = useAuthStore((s) => s.status);
  const [data, setData] = useState<HomeworkPayload | null>(null);

  useEffect(() => {
    if (status !== "authenticated") {
      setData(null);
      return;
    }
    void fetchHomework().then(setData);
  }, [status]);

  if (status !== "authenticated" || !data?.linked) return null;

  const open = data.assignments.filter(
    (a) => a.status === "assigned" || a.status === "started"
  );
  const first = open[0];

  return (
    <Card className="gap-2 border-primary/20 bg-primary/5 p-4">
      <Text variant="label" className="text-primary">
        {t("practice.fromClinician")}
      </Text>
      <Text variant="body" className="text-sm font-medium">
        {data.practiceName
          ? t("practice.linkedTo", { name: data.practiceName })
          : t("practice.linkedGeneric")}
      </Text>
      {first ? (
        <>
          <Text variant="heading" className="mt-1">
            {first.title}
          </Text>
          {first.note ? (
            <Text variant="body" className="text-sm text-text-secondary">
              {first.note}
            </Text>
          ) : null}
          {first.dueAt ? (
            <Text variant="label" className="text-text-secondary">
              {t("practice.due", {
                date: new Date(first.dueAt).toLocaleDateString(),
              })}
            </Text>
          ) : null}
          <Button
            className="mt-2 self-start"
            onClick={() =>
              void navigate({
                to: "/experiment/$assignmentId",
                params: { assignmentId: first.id },
              })
            }
          >
            {t("practice.openHomework")}
          </Button>
        </>
      ) : (
        <Text variant="body" className="text-sm text-text-secondary">
          {t("practice.noOpenHomework")}
        </Text>
      )}
    </Card>
  );
}
